<template>
  <div class="component">
    <b-container fluid class="p-25" v-if="siteId">
      <addViewSiteDocument :siteId="siteId" :isAdmin="isAdmin"></addViewSiteDocument>
    </b-container>
  </div>
</template>
<script>
import addViewSiteDocument from "@/components/common/add-view-site-document";
import localStorageService from "@/services/localStorage";

export default {
  name: "study-participant-documents",
  components: {
    addViewSiteDocument
  },
  data() {
    return {
      studyId: this.$route.params.studyId,
      siteId: null,
      isAdmin: false
    };
  },
  computed: {},
  methods: {
    getSiteId() {
      const user = localStorageService.getItem("userObj");
      if (user.userRole == "StudyAdmin") {
        this.$api.getSitesFact(this.studyId).then(response => {
          const tempSiteData = response.body;
          this.siteId = tempSiteData[0].id;
        });
      } else {
        this.siteId = user.siteIds[0];
      }
    }
  },
  mounted() {
    this.getSiteId();
  }
};
</script>
